// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JJjI","newExpiryDate":"styles_newExpiryDate__3WsqK","footer":"styles_footer__2ReMS"};